/**
 * § F179 (2026-09-18) — WHERE THE HEAD-TO-HEAD SURFACE LIVES.
 *
 * Jake: *"Change menu item 'turn-based' to 'Head To Head'."* The category is
 * called Head To Head everywhere a person reads it, and its address says the
 * same (`/head-to-head`); `/turn-based…` still resolves (`App.tsx`), because a
 * day of links and one open match on somebody's phone already point at it.
 *
 * The CODE keeps the name it was built under (`turn-based/`, `/api/turn-based`,
 * `turn_matches`): he asked for the menu item, and those are names nobody
 * types — the F26 argument.
 *
 * ONE place, because the path is written by the router, the hub door, the menu,
 * the list rows, the match's way back, the sign-in return and the your-turn
 * prompt. Seven literals is how two of them end up different.
 */
export const H2H_NAME = "Head To Head";
export const H2H_HOME = "/head-to-head";
export const H2H_WORDLE = `${H2H_HOME}/wordle`;
/** § F197 — a match lives under its own game; Wordle is the default. */
export const h2hMatchPath = (matchId: string, gameId = "wordle") => `${H2H_HOME}/${gameId}/${matchId}`;

/** § F199 — drawing a new Doodle challenge for one opponent is its own screen. */
export const h2hDoodleNewPath = (opponentId: string) => `${H2H_HOME}/doodle/new/${opponentId}`;
